import { brand } from '../../../theme/themePrimitives';
import { grey } from '@mui/material/colors';
import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

// Custom Step Connector
const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: grey[300],
    borderWidth: 2,
    height: 2
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderColor: grey[300]
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderColor: grey[300]
  }
}));

// Custom Step Icon
const CustomStepIconRoot = styled('div')<{
  active?: boolean;
  completed?: boolean;
}>(({ active, completed }) => ({
  width: completed || active ? 42 : 40,
  height: completed || active ? 42 : 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: completed || active ? 'none' : `2px solid ${grey[300]}`,
  backgroundColor: completed ? brand[50] : active ? brand[300] : 'white',
  color: completed ? brand[300] : active ? 'white' : grey[500],
  fontWeight: 600,
  fontSize: 16,
  transition: 'all 0.3s ease-in-out'
}));

const CustomStepperWrapper = styled(Stepper)(() => ({
  padding: '0',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: '300px'
}));

const CustomStepIcon: React.FC<{
  active?: boolean;
  completed?: boolean;
  icon: number;
}> = ({ active, completed, icon }) => {
  return (
    <CustomStepIconRoot active={active} completed={completed}>
      {completed ? '✔' : icon}
    </CustomStepIconRoot>
  );
};

// Props interface for the StepperComponent
interface StepperProps {
  steps: string[];
  activeStep: number;
  showLabel?: boolean;
}

// Stepper Component
const StepperComponent: React.FC<StepperProps> = ({ steps, activeStep, showLabel }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
      <CustomStepperWrapper
        alternativeLabel
        activeStep={activeStep}
        connector={<CustomConnector />}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={(props) => (
                <CustomStepIcon {...props} icon={index + 1 as number} />
              )}
            >
              {showLabel && label}
            </StepLabel>
          </Step>
        ))}
      </CustomStepperWrapper>
    </Box>
  );
};

export default StepperComponent;
